import { BASE_URL as API_BASE_URL } from '~/service/constants';

let BASE_URL = API_BASE_URL;
if (!BASE_URL.endsWith('/api')) BASE_URL = `${BASE_URL}/api`;

const headers = {
  "Content-Type": "application/json",
};

const fixSrc = (src) => {
  return window.location.hostname === 'localhost' && window.location.port === '3000'
    ? src.replace('https://api.easyllama.com', 'http://localhost:3000')
    : src;
};

const apiService = {
  get: (url, token, signal, extraHeaders = {}) => {
    const requestHeaders = {
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      ...extraHeaders,
    };

    const requestOptions = {
      method: "GET",
      headers: requestHeaders,
    };

    if (signal) {
      requestOptions.signal = signal;
    }

    return fetch(fixSrc(`${BASE_URL}${url}`), requestOptions).then((response) => response.json());
  },
  post: (url, data, token, isFile = false, extraHeaders = {}) => {
    const requestHeaders = isFile
      ? {
        ...(token && { Authorization: `Bearer ${token}` }),
      }
      : {
        ...headers,
        ...(token && { Authorization: `Bearer ${token}` }),
        ...extraHeaders,
      };

    return fetch(fixSrc(`${BASE_URL}${url}`), {
      method: "POST",
      headers: requestHeaders,
      body: isFile ? data : JSON.stringify(data),
    })
      .then((response) => {
        if (response) {
          return response.json();
        }
      })
      .catch((err) => {
        console.warn("err POST > ", err);
      });
  },
  patch: (url, data, token, extraHeaders = {}) => {
    const requestHeaders = {
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      ...extraHeaders,
    };

    return fetch(fixSrc(`${BASE_URL}${url}`), {
      method: "PATCH",
      headers: requestHeaders,
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response) {
          return response.json();
        }
      })
      .catch((err) => {
        console.warn("err PATCH > ", err);
      });
  },
};

export default apiService;
